import Api from "./api"

export default {
		home() {
			return Api().get("/events")
		},

		show(alias) {
			return Api().get("/event/" + alias)
		},

		category(category) {
			return Api().get("/products/category/" + category)
		},

		tag(tag) {
			return Api().get("/products/tag/" + tag)
		},

    subcategory(data) {
        return Api().post("/products/subcategory", data)
    },

    search(search) {
        return Api().get("/products/search/" + search)
    },
}